module.exports = __webpack_public_path__ + "img/xlb2.f41075a7.png";